// extracted by mini-css-extract-plugin
export default {"loading":"index_loading__4eOva","load":"index_load__x0E2m"};